/** PM CRUD — contact management, message/thread operations, search. */

/**
 * Clamp a recipient display name for inline use in confirmation copy, appending
 * an ellipsis when truncated. The profile `name` field is free-form and can be a
 * single unbroken token up to 120 chars (User::NAME_MAX_LEN), so interpolating it
 * whole into a fixed-width modal overflows the dialog. Default cap is 30 code
 * points. Slicing on code points (via Array.from) keeps the cap emoji-aware and
 * never splits a surrogate pair into a stray replacement glyph before the ellipsis.
 */
window.pmTruncateName = function(name, maxLen) {
  var value = String(name == null ? '' : name).trim();
  var limit = (typeof maxLen === 'number' && maxLen > 0) ? maxLen : 30;
  var chars = Array.from(value);
  if (chars.length <= limit) {
    return value;
  }
  return chars.slice(0, limit).join('').replace(/\s+$/, '') + '…';
};

window.add_contact = function() {
  let btn = $("#add_contact"),
    err_txt = "Error when adding new contact. Try again.",
    nc = $("#new_contact"),
    username = $.trim(nc.val());

  if ($("#new_contact:hidden").length) {
    nc.show();
    nc.animate({ "width": "90px", "margin-left": "-4px" }, 100);
    $("#add_contact_link").hide();
    $("#new_contact_button").show();
    return;
  }

  if (username.length < 3 || nc.attr("title") === username) {
    // Avoid double enter press after alert
    nc.blur();
    alert(window.t('common.pm.username_min_length'));
    return false;
  }

  if (!username.length) {
    alert(window.t('common.pm.enter_username'));
    return false;
  }

  btn.prop("disabled", true);

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/app/messages/add-contact",
    data: {
      "username": username
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    if (data.success) {
      // Redirect to new thread
      if (window.pm_view_mode === "paged") {
        window.location.href = window.location.protocol + "//" +
          window.location.hostname + window.location.pathname +
          "?thread_id=" + data.thread_id;
        return false;
      }
      $("#new_contact").val("");
      // Remove duplicate thread id if any
      $("#thread_" + data.thread_id).remove();
      // Add just rendered thread
      $("#threads_left").prepend(data.body);
      // Initialize thread action buttons on the new element
      if (window.initializeThreadActions) window.initializeThreadActions();
      // Make new thread active
      window.view_thread(data.thread_id, true);
    } else {
      if (data.error) {
        alert(data.error);
      } else {
        alert(err_txt);
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    alert(err_txt);
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    btn.prop("disabled", false);
  });

  return false;
};

window.get_active_thread_id = function() {
  const re = /thread_id=(\d+)/;
  const rr = re.exec(window.location.href);

  if (rr && typeof rr != "undefined" && typeof rr[1] != "undefined" && $.isNumeric(rr[1])) {
    return rr[1];
  }
  return false;
};

window.get_active_thread_uid = function() {
  let thread = $("#threads_left").find(".pm_thread.active");
  if (thread.length) {
    return thread.data("uid");
  }
  return false;
};

window.navigate_to_report = function(uid) {
  if (window.openReportModal) {
    window.openReportModal('user', uid, uid);
  } else {
    window.location = "/app/report?todo=user&uid=" + uid;
  }
};

window.delete_message = function(id) {
  // Close the dropdown menu after clicking
  window.closeMessageActionMenus();

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_message_error');
    var btn = $("#del_msg_btn_" + id),
      tid = window.get_active_thread_id();

    if (!$.isNumeric(tid)) {
      window.location.reload();
      return false;
    }

    var cogrot = $("<i class=\"fa fa-cog cog-rot\"/>");
    btn.hide();
    btn.after(cogrot);

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/delete-message",
      data: {
        "thread": tid,
        "message_id": id
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        $("#msg_" + id).remove();
        if (window.window.pm_view_mode === "chat") {
          var last = $("#threads_right").children().last();
          if (last.hasClass("pm_date_div")) {
            last.remove();
          }
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
      cogrot.remove();
      btn.show();
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t('common.pm.delete_message_title'),
      message: window.t('common.pm.delete_message_confirm'),
      confirmText: window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(window.t('common.pm.delete_message_title') + '\n\n' + window.t('common.pm.delete_message_confirm'))) {
      doDelete();
    }
  }

  return false;
};

/**
 * Remove a recalled (unsent) message bubble from the open conversation in
 * place. Idempotent: a no-op if the row is already gone, so the own-side (API
 * response) removal and the live socket path can both fire safely. IDs are
 * treated as strings.
 *
 * Sibling: the websocket recall path in pm/polling.js has its own
 * applyMessageRecallRemoval that removes the same bubble for the live socket case.
 *
 * @param {string} messageId
 */
window.applyRecallRemoval = function(messageId) {
  // Removing a row reflows the list under any open dropdown, which is positioned
  // against a viewport rect that no longer holds.
  window.closeMessageActionMenus();

  var id = String(messageId);
  $('#msg_' + id).remove();
};

window.unsend_message = function(id) {
  // Close the dropdown menu after clicking.
  window.closeMessageActionMenus();

  var msgId = String(id);
  var recipientName = $.trim($('#current_thread_username').text());
  if (!recipientName) {
    var activeRow = $('#threads_left').find('.pm_thread.active');
    recipientName = activeRow.attr('data-name') || '';
  }

  var doUnsend = function() {
    var tid = window.get_active_thread_id();
    if (!$.isNumeric(tid)) {
      window.location.reload();
      return false;
    }

    var err_txt = window.t ? window.t('legacy.pm.unsend_error') : 'Could not unsend the message. Try again.';

    if (!window.ApiClient) {
      alert(err_txt);
      return false;
    }

    window.pm_ajax_request_active = 1;
    window.ApiClient.request(
      '/message/' + msgId + '/unsend?thread_id=' + String(tid),
      { method: 'POST' }
    ).then(function(response) {
      if (response.ok) {
        window.applyRecallRemoval(msgId);
        // Refresh the thread-list snippet: the recall rolled it back to the
        // prior message server-side. Idempotent: requestPoll is debounced.
        if (window.requestPoll) {
          window.requestPoll();
        }
        return;
      }
      return response.json().then(function(data) {
        alert((data && data.message) ? data.message : err_txt);
      }).catch(function() {
        alert(err_txt);
      });
    }).catch(function() {
      alert(err_txt);
    }).then(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  var displayName = window.pmTruncateName(recipientName);

  var body = window.t
    ? window.t('legacy.pm.unsend_confirm_body', { name: displayName })
    : (displayName + " won't be able to see this message anymore.");

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t ? window.t('legacy.pm.unsend_confirm_title') : 'Unsend message?',
      message: body,
      confirmText: window.t ? window.t('legacy.pm.unsend_confirm_button') : 'Unsend',
      type: 'warning',
      onConfirm: doUnsend
    });
  } else {
    if (confirm((window.t ? window.t('legacy.pm.unsend_confirm_title') : 'Unsend message?') + '\n\n' + body)) {
      doUnsend();
    }
  }

  return false;
};

/**
 * Inline editor for a sent message (premium edit feature). Replaces the bubble
 * body with a textarea + save/cancel. On success the editor closes and the
 * bubble body is swapped by the THREAD_MESSAGE_EDITED socket event, which the
 * sender's own channel also receives (see applyMessageEditUpdate in
 * pm/polling.js). That handler sets data-edit-swapped on the row; the fetch
 * success path renders a plaintext interim only when that marker is absent, so
 * the socket's richer server-rendered (BBCode/link) HTML always wins the race
 * when the socket is up, and the sender still gets feedback when it is down.
 *
 * The raw prefill comes from data-edit-source, which PmViewBuilder renders
 * only on rows whose "Edit" action is visible (own + editable type + inside
 * the edit window). The server independently re-checks everything.
 *
 * @param {string} id
 */
window.edit_message = function(id) {
  // Close the dropdown menu after clicking.
  $('.msg-actions-menu').addClass('hidden');

  var msgId = String(id);
  var row = document.getElementById('msg_' + msgId);
  if (!row || !row.hasAttribute('data-edit-source')) {
    return false;
  }

  // One editor at a time: opening a second closes the first (restoring its
  // bubble unchanged).
  if (window._pmActiveEditCancel) {
    window._pmActiveEditCancel();
  }

  var bubbleWrap = row.querySelector('.pm-msg-bubble-wrap');
  var body = row.querySelector('.msg_body');
  if (!bubbleWrap || !body) {
    return false;
  }

  var source = row.getAttribute('data-edit-source') || '';
  var err_txt = window.t ? window.t('legacy.pm.edit_error') : 'Could not edit the message. Try again.';

  // Standard form + button components (see docs/design.md: .form-control,
  // macros/buttons.twig .button-cancel / .button-primary) so the inline editor
  // matches every other Save/Cancel surface. The textarea keeps its focus ring
  // INSIDE its box (focus-visible:ring-inset): the message row is overflow-x-clip
  // (to clip the hover pill's shadow), which would otherwise crop an outset ring
  // on the trailing edge of a right-aligned own-message editor.
  var editor = document.createElement('div');
  editor.className = 'pm-edit-editor w-[24rem] max-w-[85vw]';
  editor.innerHTML =
    '<textarea rows="3" maxlength="10000"' +
    ' class="form-control resize-y text-base focus-visible:ring-inset"></textarea>' +
    '<div class="flex items-center justify-end gap-2 mt-1">' +
    '<button type="button" class="pm-edit-cancel button-cancel"></button>' +
    '<button type="button" class="pm-edit-save button-primary"></button>' +
    '</div>';

  var ta = editor.querySelector('textarea');
  var saveBtn = editor.querySelector('.pm-edit-save');
  var cancelBtn = editor.querySelector('.pm-edit-cancel');
  ta.value = source;
  cancelBtn.textContent = window.t ? window.t('common.cancel') : 'Cancel';
  saveBtn.textContent = window.t ? window.t('common.save') : 'Save';

  // The editor replaces the whole bubble, so hide the bubble body AND its
  // in-wrap siblings — the corner time + read receipt (.pm-time) and the hover
  // action pill (.pm-msg-toolbar) — otherwise both bleed through/over the editor
  // and its Save button. Track exactly what we hid so cleanup restores only that.
  var hidden = [body];
  var pmTime = bubbleWrap.querySelector('.pm-time');
  var pmToolbar = bubbleWrap.querySelector('.pm-msg-toolbar');
  if (pmTime) { hidden.push(pmTime); }
  if (pmToolbar) { hidden.push(pmToolbar); }
  hidden.forEach(function(el) { el.classList.add('hidden'); });

  bubbleWrap.appendChild(editor);
  ta.focus();
  ta.setSelectionRange(ta.value.length, ta.value.length);

  var cleanup = function() {
    editor.remove();
    hidden.forEach(function(el) { el.classList.remove('hidden'); });
    // Only clear the global if this editor still owns it: opening a newer
    // editor reassigns it, and this editor's own async success handler must not
    // then null the newer editor's cancel.
    if (window._pmActiveEditCancel === cleanup) {
      window._pmActiveEditCancel = null;
    }
  };
  window._pmActiveEditCancel = cleanup;

  // Per-row ownership token. Opening another editor on THIS row overwrites it,
  // so this editor's async handlers can tell "a newer editor took over this
  // row" (skip: it owns the bubble now) apart from "a newer editor opened on a
  // DIFFERENT row" (this row's save must still render its own result). Gating
  // on the global _pmActiveEditCancel instead would wrongly drop this row's
  // update whenever any other editor is open.
  var editToken = String(window._pmEditSeq = (window._pmEditSeq || 0) + 1);
  row.setAttribute('data-edit-token', editToken);

  var setBusy = function(busy) {
    saveBtn.disabled = busy;
    cancelBtn.disabled = busy;
    ta.disabled = busy;
  };

  var save = function() {
    var newText = $.trim(ta.value);
    if (!newText) {
      return;
    }
    if (newText === source) {
      cleanup();
      return;
    }

    var tid = window.get_active_thread_id();
    if (!$.isNumeric(tid) || !window.ApiClient) {
      alert(err_txt);
      return;
    }

    // Clear any swap marker from a prior edit of this bubble so the socket
    // handler (which sets it when the server-rendered body lands) is the sole
    // authority on whether the authoritative render has already arrived.
    row.removeAttribute('data-edit-swapped');

    setBusy(true);
    window.pm_ajax_request_active = 1;
    window.ApiClient.request(
      '/message/' + msgId + '/edit?thread_id=' + String(tid),
      { method: 'POST', body: new URLSearchParams({ message: newText }) }
    ).then(function(response) {
      if (response.ok) {
        return response.json().then(function(data) {
          // If a newer editor took over THIS row while the save was in flight,
          // it now owns the bubble and the prefill. This superseded save must
          // not write the shared row or close the newer editor. A newer editor
          // on a DIFFERENT row leaves this row's token intact, so this row's
          // own result still renders.
          if (row.getAttribute('data-edit-token') !== editToken) {
            return;
          }

          // Keep the row's edit prefill in sync for a re-edit and update the
          // swipe/reply preview text, off the echoed raw body.
          var rendered = (data && typeof data.message === 'string') ? data.message : newText;
          row.setAttribute('data-edit-source', rendered);
          row.setAttribute('data-msg-preview', rendered.slice(0, 80));
          if (window.jQuery) { window.jQuery(row).data('msg-preview', rendered.slice(0, 80)); }

          // The THREAD_MESSAGE_EDITED socket event is the authority: it swaps in
          // the server-rendered (BBCode/link) body and sets data-edit-swapped.
          // It usually arrives before/around this response, in which case we
          // leave its render untouched. If the socket is down or slow, fall back
          // to a plaintext interim render so the sender still sees the edit take
          // effect. textContent escapes, so this is XSS-safe. When the socket
          // eventually lands it overwrites this with the richer HTML.
          //
          // The bubble's emoji-only chrome (msg_body--emoji-only / --no-bubble)
          // is intentionally NOT toggled here: that decision is the server's
          // (locale-aware emoji detection), so replicating it client-side would
          // risk drift. The authoritative socket swap corrects the chrome, so at
          // worst the sender sees the old bubble style for the interim frame.
          if (!row.hasAttribute('data-edit-swapped')) {
            var textRegion = body.querySelector('.msg-body-text');
            if (textRegion) {
              textRegion.textContent = newText;
            }
            var editedTag = row.querySelector('[data-edited-tag]');
            if (editedTag) {
              editedTag.classList.remove('hidden');
            }
          }
          cleanup();
        });
      }
      return response.json().then(function(payload) {
        // A superseded editor (a newer one opened on this row) swallows its own
        // error silently. The newer editor owns the row's feedback now.
        if (row.getAttribute('data-edit-token') !== editToken) {
          return;
        }
        // /v1 errors are nested under `error` (see FrontController\Api).
        var err = (payload && payload.error) ? payload.error : {};
        var msg = err_txt;
        if (err.code === 'edit_window_expired') {
          msg = window.t ? window.t('legacy.pm.edit_window_expired') : 'This message can no longer be edited.';
        } else if (err.code === 'edit_limit_reached') {
          msg = window.t ? window.t('legacy.pm.edit_limit_reached') : 'This message has reached its edit limit.';
        } else if (err.message) {
          msg = err.message;
        }
        alert(msg);
        setBusy(false);
      }).catch(function() {
        if (row.getAttribute('data-edit-token') !== editToken) {
          return;
        }
        alert(err_txt);
        setBusy(false);
      });
    }).catch(function() {
      if (row.getAttribute('data-edit-token') === editToken) {
        alert(err_txt);
        setBusy(false);
      }
    }).then(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  saveBtn.addEventListener('click', save);
  cancelBtn.addEventListener('click', cleanup);
  ta.addEventListener('keydown', function(e) {
    // Ignore Enter while an IME composition is active (CJK candidate commit),
    // matching the compose box. Some browsers report keyCode 229 mid-composition.
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && e.keyCode !== 229) {
      e.preventDefault();
      save();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      cleanup();
    }
  });

  return false;
};

window.mark_all_as_read = function() {
  var doMarkRead = function() {
    $.ajax({
      type: "POST",
      url: "/app/messages/mark-all-read",
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      // Auth/CSRF/onboarding gate returns {redirect: url}. The global
      // ajaxComplete handler navigates there, so skip the local reload.
      if (data && typeof data.redirect === 'string' && data.redirect) {
        return;
      }
      window.location.href = window.location.protocol + "//" +
        window.location.hostname + window.location.pathname;
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: window.t('common.pm.mark_all_read_confirm'),
      confirmText: window.t('common.confirm'),
      type: 'info',
      onConfirm: doMarkRead
    });
  } else {
    if (confirm(window.t('common.pm.mark_all_read_confirm'))) {
      doMarkRead();
    }
  }
  return false;
};

window.delete_thread = function(t, id, block_user) {
  var isBlock = block_user == 1;

  // Hide swipe actions either way — the menu/swipe affordance shouldn't linger.
  $('.thread-swipe-actions').removeClass('translate-x-0').addClass('translate-x-full');

  if (isBlock) {
    var threadEl = $('#thread_' + id);
    // Message request list rows (#3039) are not #thread_<id> rows — fall back to
    // the .message-request-row so block from the Requests list/peek resolves the
    // contact for the report step.
    if (!threadEl.length) {
      threadEl = $('.message-request-row[data-thread-id="' + id + '"], #message-request-bar[data-thread-id="' + id + '"]').first();
    }
    var contactUid = String(
      threadEl.attr('data-uid') ||
      (window.get_active_thread_uid && window.get_active_thread_uid()) ||
      ''
    );
    var contactUsername = threadEl.attr('data-name') || threadEl.find('.thread-username').text() || '';
    if (window.openBlockDeleteModal) {
      window.openBlockDeleteModal({
        threadId: id,
        contactUid: contactUid,
        contactUsername: contactUsername
      });
      return false;
    }
  }

  var title = window.t('common.pm.delete_conversation_confirm');
  var message = window.t('common.pm.delete_conversation_detail');

  var doDelete = function() {
    var err_txt = window.t('common.pm.delete_thread_error');

    window.pm_ajax_request_active = 1;
    $.ajax({
      type: "POST",
      url: "/app/messages/delete-thread",
      data: {
        "thread": id,
        "block_user": block_user
      },
      dataType: "json"
    }).done(function(data, textStatus, jqXHR) {
      if (data.success) {
        // Route through removeThreadRow so the in-flight-poll guard
        // (_recentlyRemoved) is set and the chat pane is closed only when the
        // deleted thread is the open one. A delta poll already on the wire could
        // otherwise re-insert the row we just deleted, and an unconditional pane
        // close would wipe an unrelated open conversation.
        if (typeof window.removeThreadRow === "function") {
          window.removeThreadRow(id);
        } else {
          $("#thread_" + id).remove();
          if (window.pm_view_mode === "chat") {
            $("#threads_main").removeClass("threads--open");
            if (typeof $.scrollTo === "function" && $(".cCont").length) {
              $.scrollTo($(".cCont"));
            }
            $("#threads_right").empty();
          }
        }
      } else {
        if (data.error) {
          alert(data.error);
        } else {
          alert(err_txt);
        }
      }
    }).fail(function(data, textStatus, jqXHR) {
      alert(err_txt);
    }).always(function() {
      window.pm_ajax_request_active = 0;
    });
  };

  if (window.ConfirmModal) {
    window.ConfirmModal.show({
      title: title,
      message: message,
      confirmText: window.t('common.delete'),
      type: 'danger',
      onConfirm: doDelete
    });
  } else {
    if (confirm(title + '\n\n' + message)) {
      doDelete();
    }
  }

  return false;
};

window.report_message = function(id) {
  window.closeMessageActionMenus();

  if (window.openReportModal) {
    const threadUid = window.get_active_thread_uid ? window.get_active_thread_uid() : '';
    window.openReportModal('message', id, threadUid);
  } else {
    const wl = window.location;
    wl.href = wl.protocol + "//" + wl.host + "/app/report?todo=msg&msg_id=" + id + "&thread_id=" + window.get_active_thread_id();
  }
};

window.focus_msg_box = function() {
  // Focus on msg textarea.
  // For some reason doesn't always work if we do it immediately, so add a timeout.
  window.setTimeout(function() {
    $("#message").focus();
  }, 200);
};

window.load_more_msg = function() {
  let thread_id = window.get_active_thread_id();
  if (!thread_id) return;
  window.load_more_msg_active = 1;
  window.reload_ads();
  let t = $("#threads_right");
  let container = t[0];

  // Return if no "load more" btn
  if ($("#load_older_messages").length === 0) {
    window.load_more_msg_active = 0;
    return;
  }

  // Find first date divider and message before any DOM changes
  let first_datediv = t.find(".pm_date_div:first");
  let first_msg = t.find(".pm_msg:first");
  let first_msg_id = first_msg.attr("id")?.replace("msg_", "");

  // Hide the load older button instead of removing (to avoid layout shift)
  $("#load_older_messages").css("visibility", "hidden");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;
  $.ajax({
    type: "POST",
    url: "/app/messages/load",
    data: {
      "thread": thread_id,
      "last_msg_id": first_msg_id
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // Auth/CSRF/onboarding gate returns {redirect: url}. The global
    // ajaxComplete handler navigates there, so skip rendering an error state.
    if (data && typeof data.redirect === 'string' && data.redirect) {
      return;
    }
    if (data.body) {
      let scrollTopBefore = container.scrollTop;

      // Remove load older button and prepend new content into wrapper
      $("#load_older_messages").remove();
      var wrapper = t.find('#messages_wrapper');
      var prependTarget = wrapper.length ? wrapper : t;
      prependTarget.prepend(data.body);

      // With column-reverse, prepending at the top of the wrapper adds content
      // at the visual top (furthest from scroll anchor). The browser may shift
      // scrollTop — restore it to keep the same messages in view.
      container.scrollTop = scrollTopBefore;

      // New msgs can arrive
      window.messages_highlighted = 1;

      // Remove duplicate date dividers
      if (!t.find(".no_messages").length) {
        var date = first_datediv.data("date");
        if (t.find("div[data-date=" + date + "]").length > 1) {
          first_datediv.remove();
        }
      }
    } else {
      $("#load_older_messages").remove();
      var wrapperErr = t.find('#messages_wrapper');
      var errTarget = wrapperErr.length ? wrapperErr : t;
      if (data.error) {
        errTarget.prepend(window.err_div.html(data.error));
      } else {
        errTarget.prepend(window.err_div.html(window.err_txt));
      }
    }
  }).fail(function(data, textStatus, jqXHR) {
    $("#load_older_messages").remove();
    var wrapperErr = t.find('#messages_wrapper');
    var errTarget = wrapperErr.length ? wrapperErr : t;
    errTarget.prepend(window.err_div.html(window.err_txt));
  }).always(function() {
    // Unset ajax request marker
    window.pm_ajax_request_active = 0;
    window.load_more_msg_active = 0;
  });
  return false;
};

window.reload_ads = function() {
  return; // Don't reload ads here for now (globally applied)
};

window.find_contact = function() {
  const username = $.trim($("#username_filter").val());

  const base_url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;

  if (username.length === 0) {
    window.location.href = base_url;
  } else {
    const filter_url = base_url + "?filter=username&filter_value=" + encodeURIComponent(username);
    window.location.href = filter_url;
  }

  return false;
};

let debounceTimer;
window.debounce_find_contact = function(input) {
  clearTimeout(debounceTimer);

  debounceTimer = setTimeout(function() {
    const prev = input.getAttribute("data-filter-value");

    // Only call find_contact if the value is different from the original filter value
    if ((input.value.length >= 3 || input.value.length === 0) && input.value !== prev) {
      window.find_contact();
      // Update the original value
      input.setAttribute("data-filter-value", input.value);
    }
  }, 500);
};

window.load_older_conversations = function() {
  // If all threads are already loaded, do nothing
  if (window._threadsFullyLoaded) {
    return false;
  }
  // If there's no sentinel element, there are no more conversations to load
  var sentinel = document.getElementById('load_more_conversations');
  if (!sentinel) {
    return false;
  }

  window.load_more_threads_active = 1;
  window.reload_ads();
  let c = $("#threads_left"),
    fl = $("#filters");

  // Set ajax request marker
  window.pm_ajax_request_active = 1;

  $.ajax({
    type: "POST",
    url: "/app/messages/more-threads",
    data: {
      "from": c.find(".pm_thread").length,
      "filter": fl.data("filter")
    },
    dataType: "json"
  }).done(function(data, textStatus, jqXHR) {
    // Remove old sentinel before appending to avoid duplicate IDs
    $(sentinel).remove();

    if (data.body && data.body.includes("pm_thread")) {
      // Dedupe on append: a concurrent inbox delta may have already moved a
      // thread to the top while this offset-based page was loading. Appending it
      // again would duplicate the row, so skip any thread already in the DOM.
      var tmp = document.createElement('div');
      tmp.innerHTML = data.body;
      var frag = document.createDocumentFragment();
      Array.prototype.slice.call(tmp.children).forEach(function(el) {
        if (el.classList && el.classList.contains('pm_thread') && el.id && document.getElementById(el.id)) {
          return;
        }
        frag.appendChild(el);
      });
      c[0].appendChild(frag);

      // Initialize Lucide icons on the newly appended threads
      if (window.LucideIcons) {
        window.LucideIcons.initialize(c[0]);
      }

      // Show correct action UI (desktop dropdown vs mobile swipe) on newly appended threads
      if (typeof window.initializeThreadActions === 'function') {
        window.initializeThreadActions();
      }

      // If no sentinel in the response, all threads are loaded
      if (!document.getElementById('load_more_conversations')) {
        window._threadsFullyLoaded = true;
      }
    } else {
      // No more threads to load
      window._threadsFullyLoaded = true;
    }

  }).fail(function(data, textStatus, jqXHR) {
    // Network error — stop trying to load more
    window._threadsFullyLoaded = true;
  }).always(function() {
    window.pm_ajax_request_active = 0;
    window.load_more_threads_active = 0;
  });
  return false;
};
